import { DialogRef } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { AuiButtonComponent } from '@ral/ui:aui/button';
import { injectAuiTranslationDictionary } from '@ral/utils:core/ui';
import { injectConfirmationData } from './confirmation-data.provider';

@Component({
    selector: 'aui-confirmation',
    imports: [AuiButtonComponent],
    template: `
        <div class="m-auto flex h-full max-h-[90vh] w-full max-w-[80vw] flex-col rounded-md bg-surface-background">
            <div
                class="border-gray-400 flex flex-none flex-row items-center justify-between border-b border-solid border-surface-background-darken p-4"
            >
                <span class="aui-font-medium-16">
                    {{ data.header ?? header }}
                </span>
            </div>

            <div class="flex h-full flex-col gap-4 overflow-y-auto p-4">
                <p>{{ data.message ?? message }}</p>
            </div>

            <div class="flex flex-none flex-col gap-4 border-t border-solid border-surface-background-darken p-4">
                <div class="w-full">
                    <div class="flex flex-row justify-between gap-2">
                        <aui-button
                            [label]="data.rejectLabel ?? rejectLabel"
                            (clicked)="handleReject()"
                            [color]="data.rejectStyle ?? 'gray'"
                            buttonStyle="outline"
                            size="32"
                        />
                        <aui-button
                            data-testid="aui-confirmation-accept-button"
                            [label]="data.acceptLabel ?? acceptLabel"
                            (clicked)="handleAccept()"
                            [color]="data.acceptStyle ?? 'primary'"
                            buttonStyle="solid"
                            size="32"
                            [autofocus]="true"
                        />
                    </div>
                </div>
            </div>
        </div>
    `,
})
export class ConfirmationComponent {
    public readonly data = injectConfirmationData();

    translations = injectAuiTranslationDictionary();
    header = this.translations.confirmationHeader();
    message = this.translations.confirmationMessage();
    rejectLabel = this.translations.reject();
    acceptLabel = this.translations.accept();

    public readonly dialogRef = inject(DialogRef);

    public handleAccept() {
        if (this.data.accept) this.data.accept();
        this.dialogRef.close();
    }

    public handleReject() {
        if (this.data.reject) this.data.reject();
        this.dialogRef.close();
    }
}
